export const isDebug = true;

export function debugLog(message) {
  if (isDebug) {
    console.debug(message);
  }
}

export const loaderOverlay = {
  show() {
    document.getElementById('big-loader').classList.add('visible-flex');
  },
  hide() {
    document.getElementById('big-loader').classList.remove('visible-flex');
  },
};

export function getQueryParams() {
  const params = {};
  const queryString = window.location.search.substring(1);
  const pairs = queryString.split('&');
  for (const pair of pairs) {
    if (!pair) continue;
    const [key, value] = pair.split('=');
    params[decodeURIComponent(key)] = decodeURIComponent(value || '');
  }
  return params;
};

export const appVars = {
  isModer: false,
};

window.appVars = appVars;

/**
 * Генерирует случайную строку из букв и цифр
 * @param {number} length - Длина строки (по умолчанию 32)
 * @returns {string} Случайная строка
 */
export function randomUUID(length = 32) {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}